export const RESTRICTED_EMAIL_ERROR =
  'Emails to @gmx.* and @web.de addresses may not be delivered. Please use a different email provider.';

export function isRestrictedEmailProvider(email: string) {
  return email.includes('@gmx') || email.includes('@web.de');
}
